<div class="hamburger hamburger--spring js-hamburger" [ngClass]="isActive ? 'is-active' : ''" (click)="toggleClass()">
  <div class="hamburger-box">
    <div class="hamburger-inner"></div>
  </div>
</div>
